import { Action, createReducer, on } from '@ngrx/store';
import { IDistributionChart } from '../models/user-analytics.model';
import * as actions from '../actions';

export const getFundingStatusByAgeBarChartKey = 'getFundingStatusByAgeBarChart';
export interface FundingStatusByAgeBarChartState {
  loadFundingStatusByAgeBarChartResponse: IDistributionChart[];
  loadFundingStatusByAgeBarChartResponseFailure: any;
  loaded: boolean;
}

export const initialState: FundingStatusByAgeBarChartState = {
  loadFundingStatusByAgeBarChartResponse: undefined,
  loadFundingStatusByAgeBarChartResponseFailure: undefined,
  loaded: false
};

export const reducer = createReducer(
  initialState,
  on(actions.loadFundingStatusByAgeBarChart, (state, action) => ({
    ...state
  })),
  on(actions.loadFundingStatusByAgeBarChartSuccess, (state, action) => ({
    ...state,
    loadFundingStatusByAgeBarChartResponse: action.response,
    loaded: true
  })),
  on(actions.loadFundingStatusByAgeBarChartFailure, (state, action) => ({
    ...state,
    loadFundingStatusByAgeBarChartResponseFailure: action.error
  }))
);

export const getFundingStatusByAgeBarChart = (state: FundingStatusByAgeBarChartState) => {
  if (state && state.loadFundingStatusByAgeBarChartResponse)
    return JSON.parse(JSON.stringify(state.loadFundingStatusByAgeBarChartResponse));
  else return null;
};

export const getFundingStatusByAgeBarChartIsLoaded = (state: FundingStatusByAgeBarChartState) => {
  state.loaded;
};
